// extracted by mini-css-extract-plugin
export var emptyState = "_6o-d";
export var statCard = "_6o-c";
export var table = "_6o-0";
export var tableCell = "_6o-4";
export var tableCellClickable = "_6o-5 _6o-4";
export var tableCellDefault = "_6o-6 _6o-4";
export var tableCellEmpty = "_6o-8";
export var tableCellWithValue = "_6o-7";
export var tableContainer = "_6o-e";
export var tableHeaderWeight = "_6o-1";
export var tableHeaderZone = "_6o-2";
export var tableRowHeader = "_6o-3";
export var viewModeButton = "_6o-9";
export var viewModeButtonActive = "_6o-a _6o-9";
export var viewModeButtonInactive = "_6o-b _6o-9";